import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_turnos/Eliminar_turno/Eliminar_turno.html?vue&type=template&id=7bc9a58d&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_turnos/Eliminar_turno/Eliminar_turno.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_turnos/Eliminar_turno/Eliminar_turno.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_turnos/Eliminar_turno/Eliminar_turno.css?vue&type=style&index=0&id=7bc9a58d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc9a58d",
  null
  
)

export default component.exports